import { uploadApi } from '../../../apis/uploadApi';
import Vue from 'vue';

export const LoadStatus = {
  initial: 'initial',
  loading: 'loading',
  loaded: 'loaded',
  retry: 'retry',
  error: 'error'
};

const state = {
};


const getters = {
};

const mutations = {
  SET_LOAD_STATUS(state, { resource, status }) {
    if (!state.loadStatus[resource]) {
      Vue.set(state.loadStatus, resource, {});
    }
    Vue.set(state.loadStatus, resource, status);
  }
};

const actions = {
  async uploadJSONFiles({ dispatch, commit }, { reportId, files }) {
    commit('SET_LOAD_STATUS', { resource: 'json', status: LoadStatus.loading });
    const formData = new FormData();
    files.forEach((file) => formData.append('attrZipFile', file));
    try{
      await uploadApi.post(`/api/examine-report/${reportId}/images/attributes`, formData);
      commit('SET_LOAD_STATUS', { resource: 'json', status: LoadStatus.loaded });
    }catch(error){
      console.log('error:', error);
      commit('SET_LOAD_STATUS', { resource: 'json', status: LoadStatus.error });
      // throw new Error(error.message);
    }
  },
  setLoadStatus({ commit }, { resource, status }) {
    commit('SET_LOAD_STATUS', { resource, status });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
